import React, { Component } from "react";

// Components
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";

class ConfirmProfileInfoDialog extends Component {
	constructor(props) {
		super(props);

		this.state = {
			show: props.initialShow
		};
	}

	render() {
		const { btnTranslations } = this.props;

		let buttons = [
			{
				type: Button,
				text: btnTranslations.ok,
				action: () => {
					this.setState({ show: false });
				}
			}
		];

		return this.state.show ? (
			<Modal title={this.props.title} buttons={buttons}>
				{this.props.children}
			</Modal>
		) : null;
	}
}

export default ConfirmProfileInfoDialog;



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/ConfirmProfileInfoDialog.js